import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Foxtail Millet', image: '/images/millets/foxtail.webp', link: '/millets/foxtail' },
  { name: 'Barnyard Millet', image: '/images/millets/barnyard.webp', link: '/millets/barnyard' },
  { name: 'Browntop Millet', image: '/images/millets/browntop.webp', link: '/millets/browntop' },
  { name: 'Ragi Millet', image: '/images/millets/ragi.webp', link: '/millets/ragi' },
  { name: 'Little Millet', image: '/images/millets/little.webp', link: '/millets/little' },
  { name: 'Kodo Millet', image: '/images/millets/Kodo.webp', link: '/millets/kodo' },
  { name: 'Sorgham Millet', image: '/images/millets/sorgham.webp', link: '/millets/sorgham' },
  { name: 'Pearl Millet', image: '/images/millets/pearl.webp', link: '/millets/pearl' }
];

const qtyOptions = ['500g', '1kg', '5kg', '10kg'];

const Millets = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };
  const goToProducts = () => {
    navigate('/products');
  };
  const toggleQtyType = (productIndex, qtyType) => {
    const productQuantities = selectedQuantities[productIndex] || {};
    const isSelected = qtyType in productQuantities;

    const updated = { ...productQuantities };
    if (isSelected) {
      delete updated[qtyType];
    } else {
      updated[qtyType] = 1;
    }

    setSelectedQuantities({
      ...selectedQuantities,
      [productIndex]: updated,
    });
  };

  const incrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType] || 1;

    setSelectedQuantities({
      ...selectedQuantities,
      [index]: {
        ...productQuantities,
        [qtyType]: currentQty + 1,
      },
    });
  };

  const decrementQty = (index, qtyType) => {
    const productQuantities = selectedQuantities[index] || {};
    const currentQty = productQuantities[qtyType];

    if (currentQty > 1) {
      setSelectedQuantities({
        ...selectedQuantities,
        [index]: {
          ...productQuantities,
          [qtyType]: currentQty - 1,
        },
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const quantities = selectedQuantities[index];
    if (!quantities || Object.keys(quantities).length === 0) {
      toast.warn("Please select at least one quantity!", { position: "top-right" });
      return;
    }

    Object.entries(quantities).forEach(([qtyType, qtyCount]) => {
      const item = {
        ...product,
        qtyType,
        qtyCount,
      };
      addToCart(item);
      toast.success(`${product.name} (${qtyCount} × ${qtyType}) added to cart`, {
        position: "top-right",
        autoClose: 2000,
      });
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Millets</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>
      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>
            <div className="qty-options">
              {qtyOptions.map((qtyType) => {
                const isSelected = selectedQuantities[index]?.[qtyType];

                return (
                  <div key={qtyType} className="qty-select-block">
                    <span
                      className={isSelected ? 'qty selected' : 'qty'}
                      onClick={() => toggleQtyType(index, qtyType)}
                    >
                      {qtyType}
                    </span>
                    {isSelected && (
                      <div className="qty-controls">
                        <button onClick={() => decrementQty(index, qtyType)}>-</button>
                        <span>{selectedQuantities[index][qtyType]}</span>
                        <button onClick={() => incrementQty(index, qtyType)}>+</button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />


    </section>
  );
};

export default Millets;
